module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_3016.8f616458.png";